
import React from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from "@/components/ui/card";

interface DamageTotalOverviewProps {
  totalDamageOrders: number;
  uniqueDamagedProducts: number;
  averageMonthlyDamage: string;
}

const DamageTotalOverview: React.FC<DamageTotalOverviewProps> = ({
  totalDamageOrders,
  uniqueDamagedProducts,
  averageMonthlyDamage
}) => {
  return (
    <section className="space-y-4">
      <h2 className="text-xl font-semibold">1. 📦 Totaaloverzicht</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-3xl font-bold text-center">
              {totalDamageOrders}
            </CardTitle>
            <CardDescription className="text-center">Totaal aantal schadeorders</CardDescription>
          </CardHeader>
        </Card>
        
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-3xl font-bold text-center">
              {uniqueDamagedProducts}
            </CardTitle>
            <CardDescription className="text-center">Unieke producten met schade</CardDescription>
          </CardHeader>
        </Card>

        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-xl font-bold text-center">
              {averageMonthlyDamage}
            </CardTitle>
            <CardDescription className="text-center">Gemiddelde schade per maand</CardDescription>
          </CardHeader>
        </Card>
      </div>
      
      <Card>
        <CardContent className="pt-4">
          <h3 className="font-medium mb-2">Feiten:</h3>
          <ul className="list-disc pl-6 space-y-1">
            <li>Gemiddeld 30-35 schademeldingen per maand (op basis van periode-inschatting)</li>
          </ul>
        </CardContent>
      </Card>
    </section>
  );
};

export default DamageTotalOverview;
